const storefrontToken = "5e379645ea22d3328243c7cd58c79d1f";
const apiUrl = "https://eastcoastpaintball.com/api/2023-04/graphql.json";

const brandList = [
  "HK Army", "DYE", "Planet Eclipse", "Valken",
  "GI Sportz", "Empire", "Tippmann", "First Strike"
];

let selectedBrands = [];

// Detect vendor from URL
const urlVendor = window.location.pathname.split("/").pop(); // e.g. "hk-army"
const decoded = decodeURIComponent(urlVendor.replace(/-/g, " ")).toLowerCase();

const match = brandList.find(b => b.toLowerCase() === decoded);
if (match) {
  selectedBrands = [match];
}

function buildBrandItem(brand, isChecked) {
  const encoded = encodeURIComponent(brand); // handles spaces, special characters
  return `
    <li class="item mb-10 last-0 test">
      <a href="/collections/vendors?q=${encoded}" class="bls__link-filter" aria-label="${brand}">
        <span class="checkbox${isChecked ? ' checked' : ''}"></span>
        ${brand}
        <span class="bls_tooltip-content visually-hidden">${brand}</span>
      </a>
    </li>
  `;
}

function renderBrandFilters() {
  const ul = document.getElementById("brand-filter");
  ul.innerHTML = "";

  brandList.forEach(tag => {
    const isChecked = selectedBrands.includes(tag);
    ul.innerHTML += buildBrandItem(tag, isChecked);
  });
}

async function fetchFilteredHandles() {
  const queryStr = selectedBrands.map(v => `vendor:'${v}'`).join(" OR ");
  let allHandles = [];
  let cursor = null;
  let hasNextPage = true;

  while (hasNextPage) {
    const query = `
      query {
        products(first: 250${cursor ? `, after: "${cursor}"` : ''}, query: "${queryStr}") {
          edges {
            cursor
            node { handle }
          }
          pageInfo { hasNextPage }
        }
      }
    `;

    const res = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontToken
      },
      body: JSON.stringify({ query })
    });

    const json = await res.json();
    const edges = json?.data?.products?.edges || [];

    allHandles.push(...edges.map(edge => edge.node.handle));
    hasNextPage = json.data.products.pageInfo.hasNextPage;
    cursor = edges.length > 0 ? edges[edges.length - 1].cursor : null;
  }

  return allHandles;
}

async function applyBrandFilterToExistingGrid() {
  const productGridItems = document.querySelectorAll('[data-product-handle]');

  if (selectedBrands.length === 0) {
    productGridItems.forEach(item => item.style.display = 'block');
    return;
  }

  const matchingHandles = await fetchFilteredHandles();

  productGridItems.forEach(item => {
    const handle = item.getAttribute('data-product-handle');
    item.style.display = matchingHandles.includes(handle) ? 'block' : 'none';
  });
}

// Call all on page load
renderBrandFilters();
applyBrandFilterToExistingGrid();
